// extracted by mini-css-extract-plugin
module.exports = {"price":"Pricing_price__BcKmz","grayedOut":"Pricing_grayedOut__p3dQA","referencePrice":"Pricing_referencePrice__nVvFi","newPrice":"Pricing_newPrice__UnzuX"};